import { Component } from '@angular/core';

@Component({
  selector: 'app-main-deductions',
  templateUrl: './main-deductions.component.html',
  styleUrls: ['./main-deductions.component.css'],
})
export class MainDeductionsComponent {}
